// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"318ee0b0","455":"61712d47","474":"d45ae001","977":"07c8123f"}[chunkId] + ".chunk.js";
};